import { c as _c } from "react/compiler-runtime";
import { type FC } from 'react';
import { Text } from '@endurancewarranty/ui';
import { ParameterTypeEnum } from '@lib/enums/ParameterTypeEnum';
import { QuoteTransactionModalFooter } from '@quotes/[quoteId]/payments/_components/QuoteTransactionModalFooter';
import { sidebarDialogAtom } from '@states/dialogs/sidebarDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
export type Props = {
  onClose: () => void;
  params: Record<number, string>;
};
export const DownPaymentOverpaidModal: FC<Props> = t0 => {
  const $ = _c(8);
  const {
    params
  } = t0;
  const [, setSidebarDialogState] = useJotaiAtom(sidebarDialogAtom);
  const CapturedDownPaymentAmount = Math.abs(parseFloat(params[ParameterTypeEnum.CapturedDownPaymentAmount])).toFixed(2);
  const AlteredDownPaymentAmount = Math.abs(parseFloat(params[ParameterTypeEnum.AlteredDownPaymentAmount])).toFixed(2);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text.Body size="lg" fontWeight="bold" align="left">Please Update Down Payment</Text.Body>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `The down payment price is $${AlteredDownPaymentAmount} but we've already 
        captured $${CapturedDownPaymentAmount} for it. Please adjust the down 
        payment on the select coverage page back to $${CapturedDownPaymentAmount}.`;
  let t3;
  if ($[1] !== t2) {
    t3 = <Text.Body align="left" margin="mt-4">{t2}</Text.Body>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== setSidebarDialogState) {
    t4 = <QuoteTransactionModalFooter isLoading={false} nextText="OK" onNextClick={() => {
      setSidebarDialogState({
        isOpen: false,
        children: null
      });
    }} />;
    $[3] = setSidebarDialogState;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="hide-scrollbar h-full overflow-y-auto">{t1}{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};